import { Button, Divider, message, Space, Typography } from "antd";
import { IconFont, RowCenterContainer } from "../common/components";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { HeartTwoTone } from "@ant-design/icons";
import { useLocalStorage } from "react-use";
import { RATED_POST_IDS } from "../common/utils";
import _ from "lodash";
import { useEffect, useState } from "react";
import { likePost, unlikePost } from "./slice";

const { Text } = Typography;

const Rate = ({ post }) => {
  const [showButton, setShowButton] = useState();
  const [ratedPostIds, setRatedPostIds] = useLocalStorage(RATED_POST_IDS, "");
  const { id } = post;

  useEffect(() => {
    const ids = ratedPostIds.split(",");
    setShowButton(!_.includes(ids, id));
  }, [ratedPostIds, id]);

  const addRatedPostId = () => {
    const rawRatedPostIds = _.compact(ratedPostIds.split(","));
    const newRatedPostIds = _.sortedUniq([...rawRatedPostIds, id]);
    setRatedPostIds(newRatedPostIds.join(","));
  };

  const clickLikeButton = () => {
    likePost(id)
      .then((response) => {
        addRatedPostId();
      })
      .catch((err) => {
        let errMessage = err.message;
        if (err.response) {
          errMessage = err.response.data.status.message;
        }
        message.error(errMessage);
      });
  };

  const clickUnLikeButton = () => {
    unlikePost(id)
      .then((response) => {
        addRatedPostId();
      })
      .catch((err) => {
        let errMessage = err.message;
        if (err.response) {
          errMessage = err.response.data.status.message;
        }
        message.error(errMessage);
      });
  };

  return (
    <>
      <Divider />
      <RowCenterContainer>
        {showButton ? (
          <>
            <Text
              strong
              css={css`
                padding-right: 5rem;
              `}
            >
              该文章是否有帮助？
            </Text>
            <Space size={"large"}>
              <Button type="primary" onClick={clickLikeButton}>
                是
                <IconFont
                  type={"icon-like"}
                  style={{ fontSize: "1em", paddingLeft: "1rem" }}
                />
              </Button>
              <Button type="primary" onClick={clickUnLikeButton}>
                否
                <IconFont
                  type={"icon-unlike"}
                  style={{ fontSize: "1em", paddingLeft: "1rem" }}
                />
              </Button>
            </Space>
          </>
        ) : (
          <>
            <Space>
              <HeartTwoTone twoToneColor="#eb2f96" />
              <Text
                strong
                css={css`
                  padding-right: 5rem;
                `}
              >
                感谢您的反馈！
              </Text>
            </Space>
          </>
        )}
      </RowCenterContainer>
    </>
  );
};

export default Rate;
